var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fs5 lh125 fw7 c1 mb2",attrs:{"slot":"headline"},slot:"headline"},[_vm._v(_vm._s(_vm.$t("holder")))]),_c('core-entity-card',{attrs:{"entity":_vm.holder,"isExpanded":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }